import React, { useContext } from 'react'
import AdobeAnalyticsContext from '@context/adobeAnalyticsContext'

export const useAdobeAnalytics = () => {
  return useContext(AdobeAnalyticsContext)
}

export const AdobeAnalyticsProvider = ({ children, isSdkReady = false }) => {
  return (
    <AdobeAnalyticsContext.Provider value={isSdkReady}>
      {children}
    </AdobeAnalyticsContext.Provider>
  )
}
